import { clsx, type ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

// tailwind-merge cannot tell our custom fontSize tokens (text-card-title,
// text-table-header, …) from text-<color> classes, so by default it drops
// them whenever a text-[rgb(…)] colour appears in the same cn() call. Teach
// it the tokens from tailwind.config.ts so font-size and colour merge
// independently.
const twMerge = extendTailwindMerge({
    extend: {
        classGroups: {
            'font-size': [
                {
                    text: [
                        'screen-title',
                        'section-title',
                        'card-title',
                        'headline-metric',
                        'secondary-metric',
                        'body',
                        'body-medium',
                        'annotation',
                        'table-header',
                        'table-body',
                        'pill-tag',
                        'chart-axis',
                        'chart-label',
                        'caption',
                        'search',
                        'overline',
                    ],
                },
            ],
        },
    },
});

/**
 * Combines class names using clsx and tailwind-merge.
 * Handles conditional classes and merges Tailwind conflicts.
 */
export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs));
}

/** Initials from a display name, e.g. "John Doe" -> "JD". */
export function initialsOf(name: string | null): string {
    if (!name) return '–';
    const parts = name.trim().split(/\s+/).filter(Boolean);
    if (parts.length === 0) return '–';
    const first = parts[0][0] ?? '';
    const last = parts.length > 1 ? (parts[parts.length - 1][0] ?? '') : '';
    return (first + last).toUpperCase();
}
